import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'iap',

  initialState: {
    ready: false,
  },
  reducers: {
    setIapReady(state, { payload }: PayloadAction<boolean>) {
      state.ready = payload;
    },
  },
});

export const iapActions = slice.actions;
export default slice.reducer;
